<template>
  <confirm-dialog @confirmed="removeItem">
    <template #activator="{ on, attrs }">
      <slot name="activator" v-bind:attrs="attrs" v-bind:on="on">
        <v-btn block elevation="0" small color="error" v-bind="attrs" v-on="on">
          <v-icon class="mr-2">mdi-file-document-remove-outline</v-icon>
          {{ $t("remittances-.delete") }}
        </v-btn>
      </slot>
    </template>
    <template #title>
      {{ $t("remittances-.delete") }}
    </template>
    {{ $t("remittances-.delete_question") }}
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from "../components/ConfirmDialog";
import remittances from "../../requests/remittances";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({}),
  methods: {
    removeItem: async function () {
      try {
        await remittances.delete(this.item.id);
        await this.$store.dispatch("notificator/success", this.$t("succeeded_operation"));
        this.$emit("deleted");
      } catch (e) {
        await this.$store.dispatch("notificator/errorResponse", e);
      }
    },
  },
};
</script>
